module.exports = __webpack_public_path__ + "img/1.2.f3cc3782.png";